import { createAction, props } from '@ngrx/store';
import { QueryParamsState } from './query-params.model';

export enum QueryParamActions {
  setQueryParams = '[Transaction] setQueryParams',
  setSearchParams = '[Transaction] setSearchParams',
  setTokenParam = '[Transaction] setTokenParam',
  launchTransactionStatus = '[Transaction] launchTransactionStatus',
  adddestinationCountryData = '[Transaction] destinationCountryData',
}

export const SetQueryParams = createAction(
  QueryParamActions.setQueryParams,
  props<{ queryParams: QueryParamsState; endpoint: string }>()
);

export const SetSearchParams = createAction(
  QueryParamActions.setSearchParams,
  props<{ queryParams: QueryParamsState; endpoint: string }>()
);

export const SetTokenParam = createAction(
  QueryParamActions.setTokenParam,
  props<{
    queryParams: QueryParamsState;
    endpoint: string;
    isTransactionStatus: boolean;
  }>()
);

export const LaunchTransactionStatus = createAction(
  QueryParamActions.launchTransactionStatus,
  props<{ queryParams: QueryParamsState; endpoint: string }>()
);
